<template>
  <v-list
    v-if="!stages.length"
    class="elevation-1 py-0">
    <v-list-tile
      class="py-3 text-xs-center">
      <v-icon class="mr-4">
        fas fa-exclamation-circle
      </v-icon>
      <h4>
        No hay etapas que mostrar
      </h4>
    </v-list-tile>
  </v-list>
  <v-expansion-panel v-else>
    <v-expansion-panel-content
      v-for="(stage, i) in stages"
      :key="`stage-${i}`"
      @input="$emit('select-stage', stage)"
      expand-icon="fas fa-caret-down fa-xs black--text">
      <template slot="header">
        <v-layout row wrap justify-space-between align-center>
          <v-flex md1>
            <v-avatar
              :size="50"
              class="k-orange-linear my-1">
              <h2>
                {{ i + 1 }}
              </h2>
            </v-avatar>
          </v-flex>
          <v-flex md4 class="text-xs-left">
            <h3 class="title d-inline-block">
              Días de mora {{ stage.delinquency_start }} a {{ stage.delinquency_end }}
            </h3>
          </v-flex>
          <v-flex md4 class="text-xs-center">
            <h4>
              Ventana de tiempo
            </h4>
            <span>
              {{ stage.days_off }}
            </span>
          </v-flex>
          <v-flex md3>
            <v-btn flat icon @click.stop="$emit('commute-stage', stage)">
              <v-icon :color="stage.status === 'Activo' ? 'green' : 'red'" small>
                fas fa-power-off
              </v-icon>
            </v-btn>
            <v-btn flat icon @click.stop="$emit('edit-stage', stage)">
              <v-icon color="black" small>
                fas fa-pencil-alt
              </v-icon>
            </v-btn>
            <v-btn flat icon @click.stop="$emit('delete-stage', stage)">
              <v-icon color="black" small>
                fas fa-trash-alt
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <v-card>
        <v-card-text class="px-5">
          <v-container>
            <v-layout
              v-for="(filter, i) in stage.filters"
              :key="`filters-${i}`"
              class="p-relative py-3"
              row
              wrap
              justify-space-between
              align-center>
              <v-flex md1 class="text-xs-center">
                <v-icon medium class="k-orange-linear-text">
                  fas fa-code-branch
                </v-icon>
              </v-flex>
              <v-flex md3>
                <h3 class="font-weight-regular">
                  {{ filter.name }}
                </h3>
              </v-flex>
              <v-flex md4 class="text-xs-center">
                <v-icon
                  v-for="(channel, i) in filteredChannels"
                  :key="`channel-${i}`"
                  :class="{'mr-3': true, 'k-orange-linear-text': filter[`send_${channel.name}`] }">
                  {{ channel.icon }}
                </v-icon>
              </v-flex>
              <v-flex md4 text-xs-right pr-4>
                <v-btn flat icon @click="$emit('commute-filter', filter)">
                  <v-icon :color="filter.status === 'Activo' ? 'green' : 'red'" small>
                    fas fa-power-off
                  </v-icon>
                </v-btn>
                <v-btn flat icon @click="$emit('edit-filter', filter)">
                  <v-icon small>
                    fas fa-pencil-alt
                  </v-icon>
                </v-btn>
                <v-btn flat icon @click="$emit('delete-filter', filter)">
                  <v-icon small>
                    fas fa-trash-alt
                  </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!stage.filters.length">
              <v-flex xs12 class="text-xs-center mr-5">
                <v-icon medium>
                  fas fa-info-circle
                </v-icon>
                <h4>
                  No hay filtros que mostrar
                </h4>
              </v-flex>
            </v-layout>
            <v-layout row wrap mt-4>
              <v-flex xs12 class="text-xs-right">
                <v-btn color="k-orange-linear" small @click="$emit('create-filter', stage)">
                  Crear
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Scrollbar from 'vue-perfect-scrollbar';
import channelsMixin from '@/mixins/channelsV2';

export default {
  props: {
    stages: {
      type: Array,
      required: true,
    },
  },
  components: {
    Scrollbar,
  },
  mixins: [
    channelsMixin,
  ],
  computed: {
    filteredChannels() {
      return this.channels.filter(item => ['email', 'sms', 'bot', 'ivr', 'human', 'visit'].includes(item.name));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CollectWorkflows/Detail/WorkflowTree/StagesList.vue